import { render, staticRenderFns } from "./ItemIntro.vue?vue&type=template&id=393fb028&scoped=true&"
import script from "./ItemIntro.vue?vue&type=script&lang=js&"
export * from "./ItemIntro.vue?vue&type=script&lang=js&"
import style0 from "./ItemIntro.vue?vue&type=style&index=0&id=393fb028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393fb028",
  null
  
)

export default component.exports